import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faUpwork, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { gsap } from "../../lib/gsap";
import { GITHUB, UPWORK, WHATSAPP } from "../../data/site";

export const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 17L17 7M9 7h8v8" />
  </svg>
);

export const SOCIALS = [
  { href: WHATSAPP, label: "WhatsApp", icon: faWhatsapp },
  { href: UPWORK, label: "Upwork", icon: faUpwork },
  { href: GITHUB, label: "GitHub", icon: faGithub },
];

// Fixed social icons on the left edge (desktop only)
export const SocialRail = () => (
  <aside className="rail" aria-label="Social links">
    {SOCIALS.map(({ href, label, icon }) => (
      <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
        <FontAwesomeIcon icon={icon} />
      </a>
    ))}
  </aside>
);

// Difference-blended dot that trails the pointer and grows over links
export const Cursor = () => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

    const xTo = gsap.quickTo(el, "x", { duration: 0.45, ease: "power3" });
    const yTo = gsap.quickTo(el, "y", { duration: 0.45, ease: "power3" });
    const onMove = (e) => {
      el.classList.add("cursor--active");
      xTo(e.clientX);
      yTo(e.clientY);
    };
    const onOver = (e) => {
      el.classList.toggle("cursor--hover", !!e.target.closest("a, button, [data-cursor='grow']"));
      // Over text the visitor needs to read, shrink to a dot instead
      el.classList.toggle("cursor--dot", !!e.target.closest("[data-cursor='dot']"));
    };

    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerover", onOver);
    return () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerover", onOver);
    };
  }, []);

  return <div ref={ref} className="cursor" aria-hidden="true" />;
};

// Link to workflox.net: opens in a new tab but keeps the referrer (noopener
// without noreferrer), so Workflox analytics attributes the visit to this site
export const WorkfloxLink = ({ href, children, ...rest }) => (
  // eslint-disable-next-line react/jsx-no-target-blank
  <a href={href} target="_blank" rel="noopener" {...rest}>
    {children}
  </a>
);

// Wraps a line of text so it can slide up from behind a mask on scroll
export const Mask = ({ children }) => (
  <span className="mask">
    <span>{children}</span>
  </span>
);
